/**
 * 项目路由管理
 * @author luwei
 * @version 1.0.0, 2019-03-16
 */
import Vue from 'vue'
import _ from 'lodash'
import Router from 'vue-router'
import store from '@/store'
import { Message } from 'element-ui'
// 导入业务路由定义
import { bizConstantRouter, bizAsyncRouter } from './bizConfig'

//解决重复点击同一个菜单,路由报红的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

// 常量路由，来自业务路由定义
const constantRouter = bizConstantRouter
const constLayout = () =>
  import(`@/views/common_module/console/page/frame/Layout.vue`);

const constLayout1 = () =>
  import(`@/views/common_module/base/page/layout1.vue`);

// 申报
const appleLayout = () =>
  import(`@/views/common_module/components/apply/Layout.vue`);

// 异步路由，来自业务路由定义
var asyncRouter = bizAsyncRouter;
const router = new Router({ mode: 'history', routes: constantRouter })

/**
 * 是否有权限访问某个路径
 * @param {String} toPath 该路径
 */
const hasPermission = toPath => {
  const menuUris = _.map(store.state.menus, 'menuUri')
  var arr = toPath.split('/');
  /*if(toPath.indexOf('-') != -1 && arr.length > 0 && arr[arr.length - 1].length === 36) {
    return true;
  }*/
  var flag = /\/\d$/.test(toPath);
  if(flag) {
    arr.pop();
    return _.indexOf(menuUris, arr.join('/')) >= 0 || _.indexOf(menuUris, toPath) >= 0
  }
  return _.indexOf(menuUris, toPath) >= 0
}

// 根据菜单生成路由的菜单元数据
const generateMenuName = route => {
  const menu = _.find(store.state.menus, { menuUri: route.path })
  if (!menu) {
    return
  }
  const menuName = menu.menuName
  if (route.meta) {
    route.meta.menuName = menuName
  } else {
    route.meta = { menuName }
  }
  _.forEach(route.children, child => {
    if(child.children) {
      _.forEach(child.children, childChild => {
        generateMenuName(childChild)
      })
    }
    generateMenuName(child)
  })
}

const bizAsyncRouterConfig = () => {
  var menus = store.state.asyncRouterData;
  rebuildMenu(menus);
}

const rebuildMenu = (menus) => {
  if (!menus) {
    return;
  }
  menus = JSON.parse(menus);
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    let url = menu.menuTag;
    if (url && menu.children.length == 0 && menu.menuType != -1) {
      url = false
      menu.children.push(menu)
    }
    let data = {
      path: menu.menuUri,
      name: menu.menuUri,
      children: [],
    };
    if (!url) {
      if (menu.menuType == 3) {
        data.component = appleLayout;
      } else {
        data.component = constLayout;
      }
    } else {
      console.log(menu,"menu");
      
      url = url.replace(menu.appId, '');
      url = url.substring(2);
      if (url.endsWith('.vue')) {
        url = url.substring(0, url.length - 4)
        const menuComponent = () => import(`@/${url}.vue`);
        data.component = menuComponent;
      }
    }

    var children = new Array();
    if (menu.children && menu.children.length > 0) {
      for (let j = 0; j < menu.children.length; j++) {
        let subData = menu.children[j];
        if (subData.children && subData.children.length > 0) {
          for (let k = 0; k < subData.children.length; k++) {
            let subSubData = subData.children[k];
            let son = buildMenu(subSubData);
            if (son) {
              children.push(son);
            }
          }
        }
        let child = buildMenu(subData);
        if (child) {
          children.push(child);
        }
      }
      data.children = children;
    }
    asyncRouter.push(data);
  }
}

const buildMenu = (data, children) => {
  if(!data) {
    return {};
  }
  if(!children) {
    children = new Array();
  }
  let url = data.menuTag;

  let child = {
    path: data.menuUri,
    name: data.menuUri,
    url: url,
    children: children,
  };
  if(!url) {
    if (data.menuType == 3) {
      //  申报
      child.component = appleLayout;
    } else {
      child.component = constLayout;
    }
    return child;
  }
  url = url.replace(data.appId, '');
  if(url === 'bizLayout') {
    child.component = constLayout;
  } else if(url === 'bizLayout1') {
    child.component = constLayout1;
  } else {
    url = url.substring(2);
     // 动态加载，import(`@/${url}`)这样会导致打包把所有 css 文件也都打包了;
     if (url.endsWith('.vue')) {
      url = url.substring(0, url.length - 4)
      const menuComponent = () => import(`@/${url}.vue`);
      child.component = menuComponent;
    }
  }

  // var url = require("@/views/common_module/console/page/sum/Role.vue");
  // alert('@/views/' + `${path}` + '.vue');
  // const myLayout = require('@/views/' + `${path}` + '.vue');
  // alert(myLayout);

  // child.component = (resolve) => require(['@/' + url], resolve);
  // child.component = (resolve) => require(['@/' + `${path}`], resolve);
  // const child = {
  //   path: data.menuUri,
  //   name: data.id,
  //   // component: () => import(`@/views/${path}.vue`)
  //   component: () => import(`@/views/common_module/console/page/sum/Role.vue`),
  // };
  return child;
}

// 动态生成路由表
const generateRoutes = () =>
  _.filter(asyncRouter, route => {
    const flag = hasPermission(route.path)
    if (flag) {
      generateMenuName(route)
    }
    return flag
  })
// 导航之前拦截器
router.beforeEach(async (to, from, next) => {
  sessionStorage.removeItem('compCommonFlowBusinessKey');
  sessionStorage.removeItem('compCommonFlowParentBusinessKey');
   var query = to.query;
   if (to.meta.anonymous) {
     if(query) {
        if(query.tag) {
          sessionStorage.setItem('pageDefaultRole', query.tag);
        } else {
          sessionStorage.setItem('pageDefaultRole', '');
        }
        if(query.allowEdit) {
          sessionStorage.setItem('pageAllowEdit', query.allowEdit);
        } else {
          sessionStorage.setItem('pageAllowEdit', '');
        }
        if(query.nodeCode) {
          sessionStorage.setItem('pageDefaultNodeCode', query.nodeCode);
        } else {
          sessionStorage.setItem('pageDefaultNodeCode', '');
        }
      } else {
          sessionStorage.setItem('pageDefaultRole', '');
          sessionStorage.setItem('pageAllowEdit', '');
          sessionStorage.setItem('pageDefaultNodeCode', '');
      }
     next()
     return
   }
  // 没有Token，尝试从本地存储中重新加载Token
  if (store.state.token === null) {
    const token = sessionStorage.getItem('token')
    if (token !== null && token.toUpperCase() !== 'NULL') {
      store.commit('setToken', token)
    }
  }
  // 有Token
  if (store.state.token !== null) {
    if (store.state.menus.length === 0) {
      store
      .dispatch('reloadUserAuthority')
      .then(() => {
        bizAsyncRouterConfig();
        const routes = generateRoutes()
        console.log(routes);
        let path=''
        if(routes.length === 0) {
          next('/')
          return
        }else{
          path= routes[0].children.length>0?routes[0].children[0].path:routes[0].path;
        }
        router.addRoutes(routes)
        console.log(to,"to");
        if(from.name=='login'){
          next({path:to.path=='/index'?to.path:path, replace: true })
        }else{
          next({...to, replace: true })
        }
        })
        .catch(() => {
          next('/')
        })
    } else if (hasPermission(to.path)||to.path.indexOf('/index')>-1) {
      if(query) {
          if(query.tag) {
            sessionStorage.setItem('pageDefaultRole', query.tag);
          } else {
            sessionStorage.setItem('pageDefaultRole', '');
          }
          if(query.allowEdit) {
            sessionStorage.setItem('pageAllowEdit', query.allowEdit);
          } else {
            sessionStorage.setItem('pageAllowEdit', '');
          }
          if(query.nodeCode) {
            sessionStorage.setItem('pageDefaultNodeCode', query.nodeCode);
          } else {
            sessionStorage.setItem('pageDefaultNodeCode', '');
          }
      } else {
          sessionStorage.setItem('pageDefaultRole', '');
          sessionStorage.setItem('pageAllowEdit', '');
          sessionStorage.setItem('pageDefaultNodeCode', '');
      }
      store.commit('showSusPension',[])
      // 有权限
      next()
    } else {
      Message({
        message: '该用户无权限访问',
        type: 'error'
      })
      if(to.path === '/console/dashboard') {
        store.state.menus = [];
        sessionStorage.clear();
      }
      // 无权限访问，返回到登陆页面
      next('/')
    }
  } else {
    next('/')
  }
})
router.afterEach(async (to, from) => {
  if(!to.params.durable){
    store.commit('clearNav');
  }
})
export default router
